<template>
  <div>
    <div class="pb-3">
      <VueEditor v-model="computedValue" :editorToolbar="customToolbar" :ref="textareaRefName" />
    </div>
  </div>
</template>

<script>

import { VueEditor } from "vue2-editor";
import {
  EVENT_NAME_INPUT,
  GET_NEXT_STUDY_STEP_ROUTE,
  SET_IN_PROGRESS_STUDY_OPEN_ENDED_QUESTION,
  UPDATE_STUDY
} from "@/services/constants"

export default {
  name: 'RichTextEditor',
  components: {
    VueEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    computedValue:{
      get(){
        return this.value
      },
      set(newValue){
        this.$emit(EVENT_NAME_INPUT, newValue)
      }
    },
    customToolbar() {
      return [[{ header: [false, 1, 2, 3, 4, 5, 6] }], ["bold", "italic", "link"]]
    },
    textareaRefName() {
      return 'textareaRef'
    },
  },
  methods: {
    focusFirstQuestion() {
      //$nextTick only needed for Chrome, firefox works without it
      this.$nextTick(() => {
        this.$refs[this.textareaRefName].quill.focus()
      })
    },
  },
  mounted() {
    this.focusFirstQuestion()
  }
}
</script>

<style scoped>

</style>
